import {Box, Typography} from '@mui/material';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './ReviewLeaveWithoutApprovalModal.scss';
import {useReviewHeaderContext} from '../../header/ReviewHeader';

interface GenerateArtifactsModalApprovalProps {
  open: boolean;
  onClose: () => void;
}
const ReviewLeaveWithoutApprovalModal = ({
  open,
  onClose,
}: GenerateArtifactsModalApprovalProps) => {
  const {setToIsApprovalPendingState} = useReviewHeaderContext();

  const handleContinueReviewing = () => {
    onClose();
  };

  const handleLeaveWithoutSaving = () => {
    setToIsApprovalPendingState();
  };

  const descId = 'gen-artifact-modal-desc';

  return (
    <>
      <ArrModal
        className="generateArtifactApprovalModal"
        showModal={open}
        onClose={onClose}
        showClose={false}
        title={t('ai.review.reviewLeaveModal.genArtifactApprovalModalTitle')}
        aria-label={t(
          'ai.review.reviewLeaveModal.genArtifactApprovalModalTitle'
        )}
        data-testid="gen-artifact-approval-modal"
        aria-describedby={descId}
        dataTestId="generate-artifact-approval-modal"
        buttons={[
          {
            id: 'gen-artifacts-approval-modal-leave-btn',
            label: t(
              'ai.review.reviewLeaveModal.genArtifactApprovalModalLeaveBtn'
            ),
            onClick: handleLeaveWithoutSaving,
            variant: 'secondary',
            dataTestId: 'gen-artifacts-approval-modal-leave-btn',
            className: 'gen-artifacts-approval-modal-leave-btn',
          },
          {
            id: 'gen-artifacts-approval-modal-continue-btn',
            label: t(
              'ai.review.reviewLeaveModal.genArtifactApprovalModalContinueBtn'
            ),
            onClick: handleContinueReviewing,
            variant: 'primary',
            dataTestId: 'gen-artifacts-approval-modal-continue-btn',
            className: 'gen-artifacts-approval-modal-continue-btn',
          },
        ]}
      >
        <Box id={descId}>
          <Typography
            className="typo-text body2_size generateArtifactApprovalModal-description"
            data-testid={`review-leave-without-approval-modal-gen-artifact-approval-modal-sub-text`}
          >
            {t('ai.review.reviewLeaveModal.genArtifactApprovalModalSubText')}
          </Typography>
          <Typography
            className="typo-text body2_size generateArtifactApprovalModal-description"
            data-testid={`review-leave-without-approval-modal-gen-artifact-approval-modal-desc`}
          >
            {t('ai.review.reviewLeaveModal.genArtifactApprovalModalDesc')}
          </Typography>
        </Box>
      </ArrModal>
    </>
  );
};

export default ReviewLeaveWithoutApprovalModal;
